module.exports = __webpack_public_path__ + "static/13-465aa81c2f9f9061f5824ad69ac16fb2.gif";